import { Observable } from 'rxjs';

export type NotificationVariants = 'info' | 'warning' | 'error' | 'success';
export type UserActions = 'accepted' | 'closed';

export type TNotification = {
  type: NotificationVariants;
  title: string;
  message: string;
};

export abstract class NotificationsAdapter {
  abstract userAction$: Observable<UserActions>;
  abstract notifications$: Observable<TNotification>;
  abstract notify(notification: TNotification): void;
  abstract updateUserAction(action: UserActions): void;
}
